import React, { Component}   from 'react';
import { Tabs , Tab , Glyphicon , Modal , Button} from 'react-bootstrap';
import BootstrapTable , {TableHeaderColumn} from 'react-bootstrap-table-next';
import { CSVLink} from "react-csv";
import paginationFactory from 'react-bootstrap-table2-paginator';
import cellEditFactory , {Type} from 'react-bootstrap-table2-editor';
import overlayFactory from 'react-bootstrap-table2-overlay';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import firebase from 'firebase';
import Spinner from '../Spinner';
import PropTypes from 'prop-types';
import _ from 'underscore';
import lodash from 'lodash';
import '../css/main.css';

const moment = require('moment');

let size = 0;


class YourButton extends Component {
  constructor(props) {
      super(props);
      this.handleClick = this.handleClick.bind(this);
  }

  handleClick(cell, row, rowIndex) {
      this.dialog.show({
          body: `Confirm... "${cell}"?`,
          actions: [
              Modal.Dialog.CancelAction(),
              Modal.Dialog.OKAction(() => {
              // do whatever you want
              })
          ]
      })
 }

 render() {
      const { cell, row, rowIndex } = this.props;
      return (
          <React.Fragment>
              <Button
                  bsStyle="primary"
                  onClick={() => this.handleClick(cell, row, rowIndex)}
              >Show Info</Button>
              <Modal.Dialog ref={(el) => { this.dialog = el }} />
          </React.Fragment>
      )
  }
}

const rankFormatter = (cell, row, rowIndex, formatExtraData) => {
  return (
    <div>
       <a href={cell ? cell : null} target="_blank" >
        <img src={cell}  alt="No Image found"/>
      </a>
    </div>
  );
}

const cellFormater = (cell, row, rowIndex, formatExtraData) => {
  return (
    <span>{cell}</span>
  );
}

const renderButton = (cell, row, rowIndex, formatExtraData) => {
  return (
    <button style={{wordBreak : 'break-all'}}>Edit</button>
  );
}

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total pagination">
      Showing { from } to { to } of { size } Results
    </span>
);

const dateFormat = (cell, row, rowIndex, formatExtraData) => {
  if(cell){
    return moment(cell).format('DD/MM/YYYY');
  }
  else{
    return null;
  }
}

const NoDataIndication = () => (<Spinner />)

const cellButton = (cell, row, enumObject, rowIndex) => {
  return (
      <YourButton cell={cell} row={row} rowIndex={rowIndex} />
  )
}

const options = {
    paginationSize: 5,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    alwaysShowAllBtns: false, 
    firstPageText: 'First',
    prePageText: null,
    nextPageText: null,
    lastPageText: 'Last',
    // nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    // lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [{
      text: '5', value: 5
    }, {
      text: '10', value: 10
    }, {
      text: '15', value: 15
    }, {
      text: '25', value: 25
    }, {
      text: '50', value: 50
    }, {
      text: '100', value: 100
    }
    ] 
};

const cellEditVendor = cellEditFactory({
    mode: 'click',
    blurToSave : true,
    autoSelectText: true,
    afterSaveCell : (oldValue, newValue, row, column) => { 
      var uid = firebase.auth().currentUser.uid;
      firebase.database().ref('users/vendors').child(uid).child('users').child(row.id).set(row);
      console.log('success');
    }
});

const cellEdit = {
  mode: 'click'
};

class HomeTable extends Component {

  constructor(props){
    super();
    this.state = {
      data : [],
      filename : '',
      key : 'register',
      active : false,
      columns_data : {}
    }
    this.toggleClass= this.toggleClass.bind(this); 
    this.handleSelect= this.handleSelect.bind(this); 
    this.renderColoumns= this.renderColoumns.bind(this); 
  }
  
  componentDidMount() {
    var self = this , date = new Date() , temp = {}; 
    var timestamp = date.getTime();
    var uid = this.props.uid || window.childId;
    firebase.database().ref('users/vendors').child(uid).child('users').on('value',function(snap){
      var temp = snap.val();
      self.setState({
        data : temp
      })
    })
    this.setState({
      filename : "Data_"+timestamp+".csv",
    })
  }

  toggleClass() {
    var currentState = this.state.active;
    this.setState({ active: !currentState });
  };

  handleSelect(key, path) {
    this.setState({ key });
  }

  renderColoumns(grouped){
    var te = grouped; 
    var col = Object.keys(te[0]);
    var arrayLength = col.length , result = [];
    for (var i = 0; i < arrayLength; i++) {
      var res = {}, temp = [];
      switch(col[i]){
        case "Upload Document": 
          res['formatter'] = rankFormatter;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = false;
          break ;
        case "DOB" :
          res['formatter'] = dateFormat;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = {type : Type.DATE};
          break;
        case "Farmer DOB":
          res['formatter'] = dateFormat;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = {type : Type.DATE};
          break;
        case "Nominee DOB":
          res['formatter'] = dateFormat;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = {type : Type.DATE};
          break;
        case "Date":
          res['formatter'] = dateFormat;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = {type : Type.DATE};
          break;
        case "Date Of Birth":
          res['formatter'] = dateFormat;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = {type : Type.DATE};
          break;
        case "Gender":
          res['formatter'] = cellFormater;
          res['dataField'] = col[i];
          res['text'] = col[i];
          res['editor'] = {type : Type.SELECT , options: [{value: 'Female',label: 'Female'}, {value: 'Male',label: 'Male'}, {value: 'Other',label: 'Other'}]};
          break;
        default :
          res['dataField'] = col[i];  
          res['text'] = col[i];
          res['formatter'] = cellFormater;
          res['sort'] = true;
          res['title'] = true;
          break;
      } 

      result.push(res);
    }
    console.log(result)
    return result.reverse();
  }

  render(){
    var temp = _.compact(this.state.data) , self = this , grouped;
    let columnData;
    grouped = _.groupBy(temp, 'Type');
    return(
      <div>
        <div style={{color : '#F2994A'}} className="welcome_user m-b-10">Total Number of Users :  {temp.length}</div>
        <div className = {this.props.show ? "m-40": "card_details m-40" }>
          <Tabs
            activeKey={this.state.key}
            onSelect={this.handleSelect}
            id="controlled-tab-example"
            animation>
            {
              Object.keys(grouped).map(key => 
                <Tab eventKey={key} title={key + ' Users' +"("+grouped[key].length +")"} id={key} key={key} 
                    style={{width : '100%'}}>
                    {this.props.show ? 
                    <CSVLink data={ grouped[key]} 
                       className="container-login100 m-t-20 m-b-20" 
                       style={{width : '40rem'}}>Export {key} Users in Excel</CSVLink> : null}
                    <BootstrapTable 
                      keyField='id'
                      data={ grouped[key] } 
                      columns={self.renderColoumns(grouped[key])} 
                      pagination={ paginationFactory(options) } 
                      cellEdit={cellEditVendor}
                      loading={true} 
                      bootstrap4
                      striped
                      hover
                      responsive
                    >
                      <TableHeaderColumn dataField='id' isKey>Id</TableHeaderColumn>
                      <TableHeaderColumn
                          dataField='Upload Document'
                          dataFormat={cellButton}></TableHeaderColumn>
                    </BootstrapTable>
                  {customTotal}
                </Tab>
              )
            }
          </Tabs>
        </div>
      </div>
    )
  }
}
export default HomeTable;